import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  extend, useLazyDataModel, params, string, arrayOf, shape, number, customType
} from '@thd-nucleus/data-sources';
import { itemsAddBulkProjectListItems } from '../../utils/intents.utils';

export const useAddNewIntentsProject = ({ projectId, projectRefetch, defaultListId, defaultListMutationKey }) => {
  const [createIntentsProject] = useLazyDataModel('addIntentsToProject', {
    variables: {
      projectId,
    },
    skip: !projectId,
    context: { withAuth: true },
    fetchPolicy: 'no-cache'
  });
  // mutation to be deprecated
  // eslint-disable-next-line no-unused-vars
  const [resolveBulkIntents] = useLazyDataModel('resolveBulkIntents', {
    variables: {
      mutationKey: defaultListMutationKey,
      listId: defaultListId
    },
    skip: !projectId,
    context: { withAuth: true },
    fetchPolicy: 'no-cache'
  });
  const [addBulkProjectListItems] = useLazyDataModel('addBulkProjectListItems', {
    variables: {
      projectListId: defaultListId
    },
    skip: !projectId,
    context: { withAuth: true },
    fetchPolicy: 'no-cache'
  });

  const handleCreateNewIntents = async (currentIntents, isAutoSelectionSelected) => {
    try {
      if (isAutoSelectionSelected) {
        const projectListGroups = itemsAddBulkProjectListItems(currentIntents);

        await addBulkProjectListItems({
          variables: {
            projectListId: defaultListId,
            projectListGroups
          }
        });
        await projectRefetch();
        return;
      }

      const itemsToAdd = currentIntents.map((grpIntent) => {
        return {
          groupName: grpIntent.groupName,
          items: grpIntent.materials.map((item) => ({
            description: item.intent,
            quantity: item.quantity
          }))
        };
      });
      await createIntentsProject({
        variables: {
          intents: itemsToAdd,
        }
      });

      await projectRefetch();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error creating new intents in project:', error);
    }
  };

  return {
    handleCreateNewIntents,
  };
};

useAddNewIntentsProject.propTypes = {
  projectId: PropTypes.string.isRequired,
  projectRefetch: PropTypes.func.isRequired,
  defaultListMutationKey: PropTypes.string.isRequired,
  defaultListId: PropTypes.string.isRequired
};

useAddNewIntentsProject.dataModel = extend(
  {
    addIntentsToProject: params({
      projectId: string().isRequired(),
      intents: arrayOf(customType('CreateIntentInput').shape({
        groupName: string().isRequired(),
        items: arrayOf(shape({
          description: string().isRequired(),
          quantity: number().isRequired()
        }).isRequired()).isRequired()
      }).isRequired()).isRequired()
    }).mutation().shape({
      projectId: string()
    }),
    // to be deprecated
    resolveBulkIntents: params({
      listId: string().isRequired(),
      mutationKey: string().isRequired(),
      intents: arrayOf(customType('ResolveIntentsItemRequest').shape({
        purchaseIntent: string().isRequired(),
        itemType: string().isRequired(),
        quantity: number().isRequired(),
        sku: string().isRequired(),
        itemId: string().isRequired(),
        omsId: string().isRequired()
      }).isRequired()).isRequired()
    }).mutation().shape({
      projectId: string()
    }),
    addBulkProjectListItems: params({
      projectListId: string().isRequired(),
      projectListGroups: arrayOf(customType('ProjectListGroup').shape({
        groupName: string().isRequired(),
        items: arrayOf(customType('ProjectListItem').shape({
          purchaseIntent: string().isRequired(),
          quantity: number().isRequired(),
          itemType: string().isRequired(),
          sku: string(),
          omsId: string()
        }).isRequired()).isRequired()
      }).isRequired()).isRequired()
    }).mutation().shape({
      projectListId: string()
    })
  }
);
